import React from 'react';
import { Stack, Box, Typography } from '@mui/material';
import { useIsMobile } from 'hooks';

type CreativeTypePreviewProps = {
  name: string;
  aspectRatio: number;
  dimensions: string;
};

const getStyles = (isMobile: boolean) => {
  const style = {
    color: '',
    topPadding: 2,
    alignment: 'end',
    borderColor: 'grey.300',
    backgroundColor: 'common.white',
    size: { width: 102, height: 120 },
  };

  if (isMobile) {
    style.alignment = 'center';
    style.color = 'primary.main';
    style.borderColor = 'rose.200';
    style.size = { width: 89, height: 61 };
  }
  return style;
};

const multiplePreviewFactor = 0.55;

export const CreativeTypePreview = ({ name, aspectRatio, dimensions }: CreativeTypePreviewProps) => {
  const { isMobile } = useIsMobile();

  const { size, borderColor, color, alignment, topPadding, backgroundColor } = getStyles(isMobile);

  const placeholderSizes =
    aspectRatio > 1
      ? {
          width: size.width * multiplePreviewFactor,
          height: 1 / (aspectRatio / (size.width * multiplePreviewFactor)),
        }
      : {
          height: size.height * multiplePreviewFactor,
          width: aspectRatio * size.height * multiplePreviewFactor,
        };

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{ border: 1, borderColor, pt: topPadding, pb: 2, borderRadius: 1, backgroundColor, ...size }}
    >
      {isMobile ? null : (
        <Stack justifyContent="center" alignItems="center" flexGrow={1} width="100%" height="100%" p={2}>
          <Box
            sx={{
              backgroundColor: 'rose.50',
              borderRadius: 0.333,
              width: placeholderSizes.width,
              height: placeholderSizes.height,
            }}
          ></Box>
        </Stack>
      )}
      <Stack alignItems="center" flexGrow={3} justifyContent={alignment} color={color} textAlign="center">
        <Typography variant="caption" fontWeight={700} sx={{ wordBreak: 'break-word' }} width={80}>
          {name}
        </Typography>
        <Typography variant="caption">{dimensions}</Typography>
      </Stack>
    </Stack>
  );
};
